import qs from 'qs';
import { client } from '@/client';

// 获取Broker列表
export function getBrokerList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/kafka/broker/${clusterName}/list`, others);
}

// 图表信息
export function getChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kafka/broker/${clusterName}/overview`, others);
}

// 总览数据
export function getOverview(clusterName) {
  return client.get(`/api/metrics/kafka/broker/${clusterName}/overview`);
}

/** 单个server图表数据 */
export function getServerChart(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kafka/broker/${clusterName}`, others);
}

/** 单个server总览数据 */
export function getSingleOverview(parmas) {
  const { clusterName, ...others } = parmas;
  return client.get(`/api/metrics/kafka/broker/single/${clusterName}/overview`, others);
}

// 获取配置信息
export function getConfigList(params) {
  const { clusterName, brokerId, ...others } = params;
  return client.get(`/api/metrics/kafka/broker/configuration/${clusterName}/${brokerId}`, others);
}

// 更新broker配置
export function updateBrokerConfig(params) {
  return client.put(
    `/api/resource/kafka/broker/config/update${qs.stringify(params, { addQueryPrefix: true })}`,
    params,
  );
}

// 获取dataLogs
export function getDataLogs(params) {
  const { clusterName, brokerId, ...others } = params;
  return client.get(`/api/metrics/kafka/broker/dataLogs/${clusterName}/${brokerId}`, others);
}
